import React from 'react'
import Icon from '@ant-design/icons'

// SVG Icons
import SpecieSVG from './Specie'
import BreedSVG from './Breed'
import GroupSpecieSVG from './GroupSpecie'

export const SpecieIcon = props => <Icon component={SpecieSVG} {...props} />
export const BreedIcon = props => <Icon component={BreedSVG} {...props} />
export const GroupSpecieIcon = props => <Icon component={GroupSpecieSVG} {...props} />

